/** 审批流程业务类型常量（与后端 WorkflowBizTypes 保持一致） */
export const WORKFLOW_BIZ_TYPE_DSP_SUMMARY_ADJUSTMENT = 'adjustment_audit_dsp_summary';
export const WORKFLOW_BIZ_TYPE_QC_PENALTY_UPLOAD = 'qc_penalty_upload_audit';

/** 质控罚单上传审批模板 Key（运营配置流程时使用） */
export const WORKFLOW_TEMPLATE_KEY_QC_PENALTY_UPLOAD = 'qc_penalty_upload_audit';
